/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { LayersDto } from '../../models/layers-dto';

export interface GetLayers$Params {
  applicationName: string;
}

export function getLayers(
  http: HttpClient,
  rootUrl: string,
  params: GetLayers$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<LayersDto>> {
  const rb = new RequestBuilder(rootUrl, getLayers.PATH, 'get');
  if (params) {
    rb.path('applicationName', params.applicationName, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LayersDto>;
      }),
    );
}

getLayers.PATH = '/layers/{applicationName}';
